import React, { useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Container,
  Divider,
  useMediaQuery,
  useTheme,
  Tooltip,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import GridContainer from "../../../components/grid/GridContainer.jsx";
import GridItem from "../../../components/grid/GridItem.jsx";
import CustomButton from "../SquareButton.jsx";
import { useAssessment } from "../../../providers/AssessmentProvider.jsx";
import { getAssessmentPageStyle } from "../../../components/customstyles/AssessmentPageStyle.jsx";
import { useAssessmentWalkthrough } from "../../../providers/AssessmentWalkthroughProvider.jsx";
import AssessmentWalkThroughDrawerHandler from "../AssessmentWalkThroughDrawerHandler.jsx";
import { recordCustomEvent } from "../../../pinpointConfig.js";
import { useGuidedMode } from "../../../providers/GuidedModeProvider";
import { Helmet } from "react-helmet";

const useStyles = () => {
  let theme = useTheme();
  return getAssessmentPageStyle(theme);
};

function ExpertModeAssessmentPage() {
  const styles = useStyles();
  const isMobile = useMediaQuery("(max-width: 900px)");
  const { assessment, handleExpertNotes } = useAssessment();
  const [showWalkhThroughDrawer, setShowWalkhThroughDrawer] = useState(false);
  const { showOrHideBottomBar } = useAssessmentWalkthrough();
  const { guidedMode } = useGuidedMode();
  let globalQuestionNumber = 1;

  const updatePinpointEvent = (key) => {
    recordCustomEvent(window.location.pathname + `/${key}`);
  };
  const handleWalkThroughDrawer = (key) => {
    setShowWalkhThroughDrawer(key);
    if (isMobile) {
      showOrHideBottomBar(key !== null);
    }
  };
  useEffect(() => {
    recordCustomEvent(window.location.pathname + "/guidedMode");
  }, []);

  return (
    <div
      style={{ display: "flex", justifyContent: "center" }}
      className="FSUnmask"
    >
      <Helmet>
        <title>Expert Assessment</title>
      </Helmet>
      <div
        style={{
          marginTop: "80px",
          width: "760px",
          paddingTop: "40px",
          marginBottom: isMobile ? "50px" : "100px",
        }}
      >
        {/* Loop through ALL sections */}
        {Object.values(assessment).map((assessmentData, sectionIndex) => {
          const sectionKey = Object.keys(assessment)[sectionIndex];
          return (
            <div key={sectionKey}>
              {assessmentData.sectionName === "Body Areas" && (
                <Typography style={{ ...styles.bodyAreaText }}>
                  {assessmentData.sectionName}
                </Typography>
              )}
              {assessmentData.sectionAssessment.map((item, subSectionIndex) => (
                <div
                  key={item.key}
                  style={{ ...styles.exprtSubSectionContainer }}
                >
                  <div style={{ ...styles.subSectionHeadingContainer }}>
                    <div style={{ ...styles.subSectionHeadingTextContainer }}>
                      <h3
                        style={{
                          ...styles.subSectionHeadingTextContainer.h2,
                          fontSize: "20px",
                          color: "#263238",
                          lineHeight: "28px",
                          letterSpacing: "0px",
                        }}
                      >
                        {item.name}
                      </h3>
                      <div
                        style={{ ...styles.subSectionInfoContainer }}
                        onClick={() => {
                          updatePinpointEvent(
                            `${assessmentData.key}/${item.key}/whatsthis`
                          );
                          handleWalkThroughDrawer(item.key);
                        }}
                      >
                        <Typography
                          style={{
                            ...styles.whatsNewStyle,
                          }}
                        >
                          What's This?
                        </Typography>
                        <InfoOutlinedIcon
                          fontSize="small"
                          style={{
                            fontSize: "18px",
                            opacity: 1,
                            cursor: "pointer",
                            marginLeft: "3px",
                            color: "#0D47A1",
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ ...styles.expertQuestionsTextContainer }}>
                      <p>
                        {assessmentData.sectionName === "Body Areas"
                          ? "Required"
                          : "Optional"}
                      </p>
                    </div>
                  </div>
                  <div style={{ ...styles.exprtQuestionsContainer }}>
                    <br />
                    {item.questions.map((question, questionIndex) => {
                      const selectedValue = question.selectedValue;
                      return (
                        <React.Fragment key={question.title}>
                          <GridContainer
                            style={{ padding: "2px 20px 2px 25px" }}
                          >
                            <GridItem lg={6} md={6} sm={12} xs={12}>
                              <div
                                style={{
                                  ...styles.questionsTextContainer,
                                  display: "flex",
                                  justifyContent:
                                    isMobile && !guidedMode
                                      ? "space-between"
                                      : "flex-start",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <div style={{ display: "flex", gap: "8px" }}>
                                  <p style={{ margin: 0 }}>
                                    {globalQuestionNumber++}.
                                  </p>
                                  <p style={{ margin: 0 }}>{question.title}</p>
                                </div>
                                {question.description && (
                                  <Tooltip
                                    title={question.description}
                                    placement="top"
                                    arrow
                                  >
                                    <InfoOutlinedIcon
                                      style={{
                                        fontSize: "18px",
                                        opacity: 1,
                                        cursor: "pointer",
                                        marginLeft: "7px",
                                        color: "#0D47A1",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </div>
                            </GridItem>
                            <GridItem
                              lg={assessmentData.key === "dentalStatus" ? 6 : 4}
                              md={assessmentData.key === "dentalStatus" ? 6 : 4}
                              sm={10}
                              xs={10}
                            >
                              <Container
                                style={{
                                  ...styles.optionsContainer,
                                  display: "flex",
                                  justifyContent:
                                    item.options.buttons.length === 2 &&
                                    !isMobile
                                      ? "flex-end"
                                      : !guidedMode && isMobile
                                      ? "flex-start"
                                      : "center",
                                  alignItems: "center",
                                  paddingLeft:
                                    !guidedMode && isMobile
                                      ? "0px"
                                      : styles.optionsContainer?.paddingLeft,
                                }}
                              >
                                {item.options.buttons.map((button) => (
                                  <CustomButton
                                    key={button.value}
                                    value={button.severity}
                                    label={button.name}
                                    section={sectionKey}
                                    subSectionindex={subSectionIndex}
                                    questionIndex={questionIndex}
                                    isSelected={
                                      selectedValue === button.severity
                                    }
                                  />
                                ))}
                              </Container>
                            </GridItem>
                            <GridItem lg={2} md={2} sm={2} xs={2}>
                              {!guidedMode &&
                                assessmentData.key !== "dentalStatus" && (
                                  <p
                                    style={{
                                      marginLeft: "15px",
                                      textAlign: "left",
                                      fontSize: "14px",
                                      letterSpacing: "0.4px",
                                      lineHeight: "24px",
                                      fontWeight: "400",
                                      color: "#546E7A",
                                      fontStyle:
                                        selectedValue === undefined
                                          ? "italic"
                                          : "normal",
                                    }}
                                  >
                                    {selectedValue !== undefined
                                      ? item.options.buttons.find(
                                          (b) => b.severity === selectedValue
                                        )?.name
                                      : "Not Selected"}
                                  </p>
                                )}
                            </GridItem>
                          </GridContainer>
                        </React.Fragment>
                      );
                    })}
                    <Divider sx={{ mt: 2, mb: 2, mx: "20px" }} />
                    <div style={{ margin: "18px 20px" }}>
                      <TextField
                        label="Notes"
                        multiline
                        fullWidth
                        variant="outlined"
                        value={item.notes || ""}
                        onChange={(e) =>
                          handleExpertNotes(
                            sectionIndex,
                            subSectionIndex,
                            e.target.value
                          )
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": { padding: "0px" },
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              {sectionIndex !== 2 && (
                <div style={{ marginTop: "25px", marginBottom: "20px" }}>
                  <Divider />
                </div>
              )}
            </div>
          );
        })}
      </div>
      {Object.values(assessment).map((sectionData) =>
        sectionData.sectionAssessment.map((item, index) => (
          <AssessmentWalkThroughDrawerHandler
            key={`${sectionData.key}-${item.key}`}
            item={item}
            index={index}
            isMobile={isMobile}
            handleWalkThroughDrawer={handleWalkThroughDrawer}
            showWalkhThroughDrawer={showWalkhThroughDrawer}
          />
        ))
      )}
    </div>
  );
}

export default ExpertModeAssessmentPage;
